import { FC } from "react";

import { clsxMerge } from "shared/lib/helpers";
import { PropsWithClassNameI } from "shared/lib/interfaces/ui";

interface MeetingCancelNoticePropsI extends PropsWithClassNameI {
  notice: string | null;
}

/**
 * GLE-8230: tells the rep that the disqualify they are about to submit also
 * cancels the upcoming meeting, which emails the prospect a cancellation.
 * Renders nothing when the disqualify cancels nothing.
 */
export const MeetingCancelNotice: FC<MeetingCancelNoticePropsI> = ({
  className,
  notice,
}) => {
  if (!notice) {
    return null;
  }

  return (
    <p
      role="status"
      className={clsxMerge("mb-2 text-amber-700 typography-body-5", className)}
    >
      {notice}
    </p>
  );
};
